import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';
//import {LoaderService} from '../service/loader.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable()

export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService,private cookieService: CookieService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(map(auth => {
      if (!auth) {
        this.authService.authenticated = false;
        if(!(this.router.url.includes('login') || this.router.url.includes('redirecturl'))) {
          this.cookieService.set( 'URL', this.router.url );
        }
        //this.previousRouteService.setPreviousUrl();
       this.router.navigate(['../login']);
        //window.location.href= environment.LoginURL
        return false;
      }
      this.authService.authenticated = true;
      return true;
    }));
  }
}
